import * as React from "react";
// UI frameworks
import { Button, Row, Col } from "antd";
// Utilities and hooks
import { inject, observer } from "mobx-react";
import UserStore from "state/user";
// Styles
import styles from "./index.module.scss";
import cs from "classnames";
import addCommas from "helpers/index";
import { push } from "helpers/history";
interface IProps {
	user?: UserStore | any;
}

const GoldInfo: React.FC<IProps> = (props: IProps) => {
	const ButtonGroup = Button.Group;
	return (
		<div className={styles["info"]}>
			<Row className={cs(styles["info__header"], styles["info-header"])}>
				<Col span={12} className={styles["info-header__title"]}>
					<h5>موجودی ریالی شما</h5>
				</Col>
				<Col span={12} className={styles["info-header__title"]}>
					<h5>موجودی طلای شما</h5>
				</Col>
			</Row>
			<Row className={cs(styles["info__amount"], styles["info-amount"])}>
				<Col span={12}>
					<span className={styles["info-amount__gram"]}>
						{props.user.loading ? (
							<small>درحال بارگزاری...</small>
						) : (
							<span>
								{addCommas(props.user.balance) || 0} <small>ریال</small>
							</span>
						)}
					</span>
				</Col>
				<Col span={12}>
					<span className={styles["info-amount__gram"]}>
						{props.user.loading ? (
							<small>درحال بارگزاری...</small>
						) : (
							<span>
								{props.user.goldCredit.toFixed(4)} <small>گرم</small>
							</span>
						)}
					</span>
				</Col>
			</Row>

			<ButtonGroup className={styles["info__btns"]}>
				<Button onClick={() => push("dashboard/issue")}> خرید طلا</Button>
				<Button onClick={() => push("dashboard/sell")}>فروش طلا</Button>
			</ButtonGroup>
		</div>
	);
};

// @ts-ignore
export default inject("user")(observer(GoldInfo));
